import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_2 = { class: "flex flex-wrap w-full space-y-2 md:space-x-2 md:flex-nowrap md:space-y-0" }
const _hoisted_3 = { class: "flex w-full md:w-3/5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-search",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" })
], -1)
const _hoisted_5 = { class: "flex flex-wrap items-center justify-between w-full md:w-2/5" }
const _hoisted_6 = { class: "flex flex-wrap justify-end w-full" }
const _hoisted_7 = { class: "flex items-center justify-end w-full" }
const _hoisted_8 = { class: "mt-8 overflow-x-scroll min-h-[420px]" }
const _hoisted_9 = { class: "w-full table-auto" }
const _hoisted_10 = { class: "font-bold text-left capitalize border-b-2 border-black divide-x divide-gray-300" }
const _hoisted_11 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_12 = { class: "flex items-center justify-between" }
const _hoisted_13 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_14 = { class: "relative flex items-center justify-between" }
const _hoisted_15 = { class: "flex items-center space-x-1" }
const _hoisted_16 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_17 = { class: "relative flex items-center justify-between" }
const _hoisted_18 = { class: "flex items-center space-x-1" }
const _hoisted_19 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_20 = { class: "relative flex items-center justify-between" }
const _hoisted_21 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_22 = { class: "relative flex items-center justify-between" }
const _hoisted_23 = { class: "flex items-center space-x-1" }
const _hoisted_24 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_25 = { class: "flex items-center justify-between" }
const _hoisted_26 = {
  scope: "col",
  class: "relative flex items-center justify-between px-2 py-2"
}
const _hoisted_27 = { class: "flex items-center space-x-1" }
const _hoisted_28 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_29 = { class: "px-2 py-6 capitalize md:py-3 whitespace-nowrap md:whitespace-normal" }
const _hoisted_30 = { class: "px-2 py-6 capitalize md:py-3 whitespace-nowrap md:whitespace-normal" }
const _hoisted_31 = { class: "block whitespace-nowrap" }
const _hoisted_32 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_33 = { class: "px-2 py-2 capitalize" }
const _hoisted_34 = { class: "px-2 py-2 capitalize" }
const _hoisted_35 = { class: "block whitespace-nowrap md:whitespace-normal" }
const _hoisted_36 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_37 = { class: "px-2 py-2 capitalize" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "px-2 py-2 capitalize" }
const _hoisted_41 = { class: "px-2 py-2 whitespace-nowrap md:whitespace-normal" }

import { computed, onMounted, ref } from "vue";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";

import AlertCard from "@/components/AlertCard.vue";
import RoleGuard from "@/components/RoleGuard.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import RouterButton from "@/components/RouterButton.vue";
import TimezoneSpan from "@/components/TimezoneSpan.vue";
import PaginationBar from "@/components/PaginationBar.vue";
import DefaultButton from "@/components/DefaultButton.vue";
import ExportDataModal from "@/components/modals/ExportDataModal.vue";
import FilterTableHeader from "@/components/tables/FilterTableHeader.vue";
import SortableTableHeader from "@/components/tables/SortableTableHeader.vue";

import api from "@/api/api";
import { useUserStore } from "@/store";
import { userHasRole } from "@/utils/roles";
import { PaginationMeta, Club } from "@/types";
import { useFilters } from "@/composables/filters";
import { brickClubsSettingOptions } from "@/utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClubsList',
  setup(__props) {

const route = useRoute();
const { user } = storeToRefs(useUserStore());
const { filters, getFiltersFromQuery, filter, setFilter, resetFilters, sortBy } = useFilters(route);

const isExportModalOpen = ref(false);
const isExportModalGoalsOpen = ref(false);
const isLoading = ref(true);

const clubs = ref([] as Club[]);
const locations = ref([] as string[]);
const meta = ref({} as PaginationMeta);

const allRoles = [
  "admin",
  "clubs-admin",
  "facilitator-organisation",
  "advanced-facilitator",
  "advanced-facilitator-trainee",
  "certified-facilitator",
  "parent",
  "brick-club-family",
];
const facilitatorFilters = ref([] as { key: string; value: string }[]);
const dateFilters = ref(["week", "month"]);
const settings = brickClubsSettingOptions;
const statusFilters = ref(["all", "published", "completed"]);

const isFacilitator = computed(() => {
  return userHasRole(user.value.roles, ["advanced-facilitator", "certified-facilitator"]);
});

async function search() {
  const response = await api.clubs.listClubs(filters.value as any);
  clubs.value = response.data.clubs;
  locations.value = response.data.countries;
  facilitatorFilters.value = response.data.facilitators.map((f: any) => ({
    key: `${f.first_name} ${f.last_name}`,
    value: f.id,
  }));
  meta.value = response.meta;
}

onMounted(async () => {
  isLoading.value = true;

  if (!user.value.has_brick_club_access) {
    isLoading.value = false;
    return;
  }

  if (userHasRole(user.value.roles, ["parent", "brick-club-family"])) {
    const response = await api.students.listParentStudentClubs(user.value.id);

    clubs.value = response.data.clubs;
    meta.value = response.meta;
  } else {
    getFiltersFromQuery();
    await search();
  }
  isLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ExportDataModal, {
      isOpen: isExportModalOpen.value,
      title: "Export Brick Club Data",
      onClose: _cache[0] || (_cache[0] = ($event: any) => (isExportModalOpen.value = false)),
      type: "clubs"
    }, null, 8, ["isOpen"]),
    _createVNode(ExportDataModal, {
      isOpen: isExportModalGoalsOpen.value,
      title: "Export Brick Club Goals Data",
      onClose: _cache[1] || (_cache[1] = ($event: any) => (isExportModalGoalsOpen.value = false)),
      type: "goals"
    }, null, 8, ["isOpen"]),
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _unref(isFacilitator) ? _ctx.$t('my-brick-clubs') : _ctx.$t('brick-clubs')
      }, null, 8, ["title"])
    ]),
    (!isLoading.value && !_unref(user).has_brick_club_access)
      ? (_openBlock(), _createBlock(AlertCard, {
          key: 0,
          type: "warning",
          class: "mt-4"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("no-brickclub-access-description")), 1)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!isLoading.value && _unref(user).has_brick_club_access)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                type: "search",
                id: "search",
                onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_unref(filter) && _unref(filter)(...args)), ["enter"])),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(filters).query) = $event)),
                class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded-l",
                placeholder: "Search ...",
                required: ""
              }, null, 544), [
                [_vModelText, _unref(filters).query]
              ]),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(filter) && _unref(filter)(...args))),
                class: "flex items-center h-10 px-4 py-2 space-x-2 text-white rounded-r whitespace-nowrap bg-primary hover:bg-blue-700"
              }, [
                _hoisted_4,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("search")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(RoleGuard, { roles: ['admin', 'facilitator-organisation', 'advanced-facilitator', 'clubs-admin', 'certified-facilitator', 'advanced-facilitator-trainee'] }, {
                default: _withCtx(() => [
                  _createVNode(RouterButton, {
                    type: "primary",
                    loading: false,
                    disabled: false,
                    to: { path: '/dashboard/clubs/new' }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("create-brick-club")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(RoleGuard, { roles: ['admin', 'clubs-admin'] }, {
                default: _withCtx(() => [
                  _createVNode(DefaultButton, {
                    type: "primary",
                    loading: false,
                    disabled: false,
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (isExportModalOpen.value = true))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("export-club-data")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          (!isLoading.value)
            ? (_openBlock(), _createBlock(RoleGuard, {
                key: 0,
                class: "mt-2",
                roles: ['admin', 'clubs-admin']
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(DefaultButton, {
                        type: "primary",
                        loading: false,
                        disabled: false,
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (isExportModalGoalsOpen.value = true))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("export-goals-data")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_10, [
                  _createElementVNode("th", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(`name`)), 1),
                      _createVNode(SortableTableHeader, {
                        column: "name",
                        onSort: _unref(sortBy)
                      }, null, 8, ["onSort"])
                    ])
                  ]),
                  _createElementVNode("th", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(`first-date`)), 1),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(FilterTableHeader, {
                          label: "timeframe",
                          currentValue: _unref(filters).timeframe,
                          filters: dateFilters.value,
                          onChange: _unref(setFilter),
                          onReset: _unref(resetFilters)
                        }, null, 8, ["currentValue", "filters", "onChange", "onReset"]),
                        _createVNode(SortableTableHeader, {
                          column: "first_club_date",
                          onSort: _unref(sortBy)
                        }, null, 8, ["onSort"])
                      ])
                    ])
                  ]),
                  _createElementVNode("th", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(`facilitator`)), 1),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(FilterTableHeader, {
                          label: "facilitator",
                          currentValue: _unref(filters).facilitator,
                          filters: facilitatorFilters.value,
                          onChange: _unref(setFilter),
                          onReset: _unref(resetFilters),
                          isObjectArray: true
                        }, null, 8, ["currentValue", "filters", "onChange", "onReset"])
                      ])
                    ])
                  ]),
                  _createElementVNode("th", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createTextVNode(_toDisplayString(_ctx.$t(`location`)) + " ", 1),
                      _createVNode(FilterTableHeader, {
                        label: "location",
                        currentValue: _unref(filters).location,
                        filters: locations.value,
                        onChange: _unref(setFilter),
                        onReset: _unref(resetFilters)
                      }, null, 8, ["currentValue", "filters", "onChange", "onReset"])
                    ])
                  ]),
                  _createElementVNode("th", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createTextVNode(_toDisplayString(_ctx.$t(`setting`)) + " ", 1),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(SortableTableHeader, {
                          column: "setting",
                          onSort: _unref(sortBy)
                        }, null, 8, ["onSort"]),
                        _createVNode(FilterTableHeader, {
                          label: "setting",
                          currentValue: _unref(filters).setting,
                          filters: _unref(settings),
                          onChange: _unref(setFilter),
                          onReset: _unref(resetFilters)
                        }, null, 8, ["currentValue", "filters", "onChange", "onReset"])
                      ])
                    ])
                  ]),
                  _createElementVNode("th", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(`capacity`)), 1),
                      _createVNode(SortableTableHeader, {
                        column: "capacity",
                        onSort: _unref(sortBy)
                      }, null, 8, ["onSort"])
                    ])
                  ]),
                  _createElementVNode("th", _hoisted_26, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`status`)), 1),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(SortableTableHeader, {
                        column: "status",
                        onSort: _unref(sortBy)
                      }, null, 8, ["onSort"]),
                      _createVNode(FilterTableHeader, {
                        label: "status",
                        currentValue: _unref(filters).status,
                        filters: statusFilters.value,
                        onChange: _unref(setFilter),
                        onReset: _unref(resetFilters)
                      }, null, 8, ["currentValue", "filters", "onChange", "onReset"])
                    ])
                  ]),
                  _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.$t(`actions`)), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clubs.value, (club) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "border-b border-gray-400 divide-x divide-gray-300",
                    key: club.id
                  }, [
                    _createElementVNode("td", _hoisted_29, _toDisplayString(club.name), 1),
                    _createElementVNode("td", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(TimezoneSpan, {
                          date: club.first_club_date,
                          locale: "en-GB",
                          "date-style": "short",
                          "time-style": "long",
                          showTime: false
                        }, null, 8, ["date"])
                      ]),
                      (club.last_club_date)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, "-"))
                        : _createCommentVNode("", true),
                      _createVNode(TimezoneSpan, {
                        date: club.last_club_date,
                        locale: "en-GB",
                        "date-style": "short",
                        "time-style": "long",
                        showTime: false
                      }, null, 8, ["date"])
                    ]),
                    _createElementVNode("td", _hoisted_33, _toDisplayString(club.facilitator.first_name) + " " + _toDisplayString(club.facilitator.last_name), 1),
                    _createElementVNode("td", _hoisted_34, [
                      _createElementVNode("span", _hoisted_35, _toDisplayString(`${club.address_line_one} ${club.address_line_two !== null ? `, ${club.address_line_two}` : ""}`), 1),
                      _createElementVNode("span", null, _toDisplayString(`${club.city}, ${club.country}`), 1)
                    ]),
                    _createElementVNode("td", _hoisted_36, _toDisplayString(club.setting), 1),
                    _createElementVNode("td", _hoisted_37, [
                      (!club.places_available)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(club.participants_count) + " - (" + _toDisplayString(_ctx.$t("full")) + ")", 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(club.participants_count), 1))
                    ]),
                    _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.$t(club.status)), 1),
                    _createElementVNode("td", _hoisted_41, [
                      _createVNode(RoleGuard, {
                        roles: allRoles.filter(i => i !== 'parent').filter(i => i !== 'brick-club-family')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: `/dashboard/clubs/${club.id}`,
                            class: "text-blue"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("manage-brick-club")), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _: 2
                      }, 1032, ["roles"]),
                      _createVNode(RoleGuard, { roles: allRoles }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_link, {
                            to: `/dashboard/clubs/${club.id}`,
                            class: "text-blue"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("view")), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createVNode(PaginationBar, { meta: meta.value }, null, 8, ["meta"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})